import { useDispatch } from "react-redux";
import {fetchStakingData} from "../staking";
import {useEthereum} from "../../EthereumContext";

export const useFetchStaking = () => {
    const {roobee, staking, account} = useEthereum();
    const dispatch = useDispatch();

    const fetchStaking = () => dispatch(fetchStakingData({account, staking, roobee}));

    return {
        fetchStaking
    };
}
